import moment from 'moment';
import React, { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { useAppContext } from '../../../appProvider/contextProvider';
import Calendars from '../../../components/Calendars/Calendars';
import HelperComponent from '../../../components/HelperComponent/HelperComponent';
import PremiumLock from '../../../components/PremiumFeatures/PremiumLock';
import { ERRORS } from '../../../constants/AppConstants';
import { getBasicAutomationStats, updateBasicAutomation } from '../../../services/automationService';
import roundOff from '../../../Util/roundOff';



const BasicAutomation = () => {

    const history = useHistory();
    const {selectedWebsite, isFeatureAvailable} = useAppContext();
    const [basicAutomationStats, setBasicAutomationStats] = useState(null);

    const [isFilterOpen , setIsFilterOpen] = useState(false);
    
    const [subscribersFilter, setSubscribersFilter] = useState({
        name: 'Last 7 Days',
        startDay: moment().subtract(7, 'days').startOf('day'),
        endDay: moment(),
    });

    // const [welcomeNotification, setWelcomeNotification] = useState(false);
    // const [dripNotification, setDripNotification] = useState(false);


    useQuery(['fetchDripStats', {
            webId: selectedWebsite?.id,
            start_date: subscribersFilter.startDay,
            end_date: subscribersFilter.endDay,
        }], () => getBasicAutomationStats({
            webId: selectedWebsite?.id,
            start_date: subscribersFilter.startDay,
            end_date: subscribersFilter.endDay,
        }),
        {
            enabled: !!selectedWebsite,
            onSuccess: (basicStats) => {
                setBasicAutomationStats(basicStats);
            }
        }
    );



    const disableWelcomeNotification = useMutation((event) => {
        event.preventDefault();
        const welcomePayload = {
            welcome_notification: {
                is_active: !basicAutomationStats.welcome_notification?.is_active,
            }
        }
        return updateBasicAutomation(selectedWebsite?.id, welcomePayload);
    }, {
        onSuccess: (basicStats) => {
            if(basicStats.errors) {

            }else {
                basicAutomationStats.welcome_notification.is_active = basicStats.welcome_notification.is_active;
                toast.success(`Welcome Notification 
                    ${basicAutomationStats.welcome_notification.is_active ? 'enabled' : 'disabled'}
                    successfully
                    `);
                setBasicAutomationStats(basicAutomationStats);
            }
        }
    });

    const disableDripNotification = useMutation((event) => {
        event.preventDefault();
        const dripPayload = {
            drip_notification: {
                is_active: !basicAutomationStats.drip_notification?.is_active,
            }
        }
        return updateBasicAutomation(selectedWebsite?.id, dripPayload);
    }, {
        onSuccess: (basicStats) => {
            if(basicStats.errors) {
                if(basicStats.errors.drip_notification) {
                    toast.error(ERRORS[basicStats.errors.drip_notification.drip_notification]);
                }
            }else {
                basicAutomationStats.drip_notification.is_active = basicStats.drip_notification.is_active;
                toast.success(`Drip Notification 
                    ${basicAutomationStats.drip_notification.is_active ? 'enabled' : 'disabled'}
                    successfully
                    `);
                setBasicAutomationStats(basicAutomationStats);
            }
        }
    });

    const disableRssFeed = useMutation((event) => {
        event.preventDefault();
        const dripPayload = {
            rss_feed: {
                is_active: !basicAutomationStats.rss_feed?.is_active,
            }
        }
        return updateBasicAutomation(selectedWebsite?.id, dripPayload);
    }, {
        onSuccess: (basicStats) => {
            if(basicStats.errors) {
                if(basicStats.errors.rss_feed) {
                    toast.error(ERRORS[basicStats.errors.rss_feed.rss_feed]);
                }
            }else {
                basicAutomationStats.rss_feed.is_active = basicStats.rss_feed.is_active;
                toast.success(`Rss Feeds 
                    ${basicAutomationStats.rss_feed.is_active ? 'enabled' : 'disabled'}
                    successfully
                    `);
                setBasicAutomationStats(basicAutomationStats);
            }
        }
    });

    const getCustomRange = () => {
        return `${moment(subscribersFilter.startDay).format('DD/MM/YYYY')} - ${moment(subscribersFilter.endDay).format('DD/MM/YYYY')}`;
    }

    return <>
        <div className="panel full-height">
            <div className="panel-header">
                <div className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0">
                        Basic Automation
                        <HelperComponent component={'Basic Automation'} href="https://chirpyweb.com/documentation_posts/basic-automation/" />
                    </h3>
                    <div className="col col-md-3 form-group date-form-group mb-0" >
                        <div className="input-addon input-group-right" onClick={() => setIsFilterOpen(!isFilterOpen)} >
                            <i className="icon icon-calendar"></i>
                            <input
                                value={subscribersFilter.name !== 'Custom Dates' ? subscribersFilter.name : getCustomRange() }
                                placeholder="This Week" 
                                className="form-control"
                            />
                        </div>
                        {
                            isFilterOpen && <Calendars
                                subscribersFilter={subscribersFilter}
                                setSubscribersFilter={setSubscribersFilter}
                                setIsFilterOpen={setIsFilterOpen}
                            />
                        }
                    </div>
                </div>                                
            </div>
            <div className="panel-body scrollable_y">
                <div className="d-flex flex-column">                              
                    <div className="row align-items-center automation-categories">
                        <div className="col-12 col-lg-5 br-right">
                            <h5 className="text-dark medium">Welcome Notifications</h5>
                            <p className="text-light thin">Show your appreciation by sending a warm
                                welcome notification as soon as a user subscribes.</p>
                        </div>
                        <div className="col">
                            <label className="thin text-light">Sent</label>
                            <h5 className="text-dark">{roundOff(basicAutomationStats?.welcome_notification?.sent || 0)}</h5>
                        </div>
                        <div className="col">
                            <label className="thin text-light">Impressions</label>
                            <h5 className="text-dark">{roundOff(basicAutomationStats?.welcome_notification?.delivered || 0)}</h5>
                        </div>
                        <div className="col">
                            <label className="thin text-light">Clicks</label>
                            <h5 className="text-dark">{roundOff(basicAutomationStats?.welcome_notification?.opened || 0)}</h5>
                        </div>
                        <div className="col" data-toggle-position="top-right">
                            <label className="thin text-light d-none d-lg-block">Active</label>
                            <label className="toggle-control toggle-control-sm">
                                <input type="checkbox"  onChange={disableWelcomeNotification.mutate} checked={basicAutomationStats?.welcome_notification?.is_active} />
                                <span className="control"></span>
                            </label>
                        </div>
                        <div className="col align-self-center">
                            <button className="btn btn-primary" onClick={() => history.push('/welcome-notification')} >Setup</button>
                        </div>
                    </div>
                    <div className="row align-items-center automation-categories">
                        <div className="col-12 col-lg-5 br-right">
                            <h5 className="text-dark medium">Drip Notifications</h5>
                            <p className="text-light thin">A sequence of notifications sent to the subscriber once
                                they subscribe notifications</p>
                        </div>
                        {      !isFeatureAvailable('drip-notification') 
                                ? <div className="col d-flex align-items-center justify-content-center">
                                    This feature is available with Premium Plan
                                    <PremiumLock />
                                    </div>
                                : <>
                                    <div className="col">
                                        <label className="thin text-light">Sent</label>
                                        <h5 className="text-dark">{roundOff(basicAutomationStats?.drip_notification?.sent || 0)}</h5>
                                    </div>
                                    <div className="col">
                                        <label className="thin text-light">Impressions</label>
                                        <h5 className="text-dark">{roundOff(basicAutomationStats?.drip_notification?.delivered || 0)}</h5>
                                    </div>
                                    <div className="col">
                                        <label className="thin text-light">Clicks</label>
                                        <h5 className="text-dark">{roundOff(basicAutomationStats?.drip_notification?.opened || 0)}</h5>
                                    </div>
                                    <div className="col" data-toggle-position="top-right">
                                        <label className="thin text-light d-none d-lg-block">Active</label>
                                        <label className="toggle-control toggle-control-sm">
                                            <input type="checkbox" onChange={disableDripNotification.mutate} checked={basicAutomationStats?.drip_notification?.is_active}/>
                                            <span className="control"></span>
                                        </label>
                                    </div>
                                    <div className="col align-self-center">
                                        <button className="btn btn-primary" onClick={() => history.push('/drip-notification')}>Setup</button>
                                    </div>
                                </>
                        }
                    </div>
                    <div className="row align-items-center automation-categories">
                        <div className="col-12 col-lg-5 br-right">
                            <h5 className="text-dark medium">RSS Field</h5>
                            <p className="text-light thin">Automated notifications through RSS Feed.</p>
                        </div>
                        {      !isFeatureAvailable('rss-feed') ? <div className="col d-flex align-items-center justify-content-center">
                                    This feature is available with Premium Plan
                                    <PremiumLock />
                                    </div>
                                : <>
                                    <div className="col">
                            <label className="thin text-light">Sent</label>
                            <h5 className="text-dark">{basicAutomationStats?.rss_feed?.sent || 0}</h5>
                        </div>
                                    <div className="col">
                                        <label className="thin text-light">Impressions</label>
                                        <h5 className="text-dark">{basicAutomationStats?.rss_feed?.delivered || 0}</h5>
                                    </div>
                                    <div className="col">
                                        <label className="thin text-light">Clicks</label>
                                        <h5 className="text-dark">{basicAutomationStats?.rss_feed?.opened || 0}</h5>
                                    </div>
                                    <div className="col" data-toggle-position="top-right">
                                        <label className="thin text-light d-none d-lg-block">Active</label>
                                        <label className="toggle-control toggle-control-sm">
                                            <input type="checkbox" onChange={disableRssFeed.mutate} checked={basicAutomationStats?.rss_feed?.is_active} />
                                            <span className="control"></span>
                                        </label>
                                    </div>
                                    <div className="col align-self-center">
                            <button className="btn btn-primary" onClick={() => history.push('/rss-setup')}>Setup</button>
                        </div>
                                </>
                        }   
                    </div>
                </div>
            </div>
        </div>
    </>
}


export default BasicAutomation;